export default Object.freeze({
  Unset: {
    name: null,
    icon: 'fa fa-exchange-alt',
  },
  LogInterface: {
    name: 'Log Interface',
    icon: 'fa fa-globe',
  },
  CambioDeEstatus: {
    name: 'Cambio de Estatus',
    icon: 'fa fa-exchange-alt',
  },
});
